<template>
  <div class="container bg-white">
    <!-- logo -->
    <div class="logo-list">
      <img :src="logoImgPath" alt />
    </div>
    <!-- 表单 -->
    <div class="form-list">
      <!-- 手机号 -->
      <div>
        <!-- pc浏览器测试时使用 @keyup="handleMobileNumKeyUp" -->
        <input type="tel" v-model="mobileNum" maxlength="13" placeholder="请输入手机号码" @keyup="handleMobileNumKeyUp" />
        <div v-show="mobileNum" @click="handleClearMobileNumClick">
          <img :src="require('@/assets/clear.png')" alt />
        </div>
      </div>
      <!-- 验证码 -->
      <div>
        <!-- pc浏览器测试时使用 @keyup="handleCodeKeyUp" -->
        <input type="tel" v-model="validateCode" maxlength="6" placeholder="请输入验证码" @input="handleCodeKeyUp" />
        <button :disabled="codeBtnDisabled" @click="handleCodeBtnClick">{{ codeBtnLabel }}</button>
      </div>
      <!-- 密码 -->
      <div>
        <!-- pc浏览器测试时使用 @keyup="handlePwd1KeyUp" -->
        <input :type="pwd1InputType" v-model="pwd1" maxlength="30" placeholder="登录密码(6位以上数字或字母)"
          @input="handlePwd1KeyUp" />
        <div @click="handleShowPwd1Click">
          <svg-icon :icon-class="pwd1SvgEyePath" class-name="cur-icon"></svg-icon>
        </div>
      </div>
      <!-- 确认密码 -->
      <div>
        <!-- pc浏览器测试时使用 @keyup="handlePwd2KeyUp" -->
        <input :type="pwd2InputType" v-model="pwd2" maxlength="30" placeholder="确认登录密码" @input="handlePwd2KeyUp" />
        <div @click="handleShowPwd2Click">
          <svg-icon :icon-class="pwd2SvgEyePath" class-name="cur-icon"></svg-icon>
        </div>
      </div>
      <!--2024.4.19 销售码-->
      <div v-show="isReferralCode">
        <input type="tel" v-model="referralCode" maxlength="30" placeholder="请输入销售码" @keyup="handleReferralCodeKeyUp" />
      </div>
    </div>
    <!-- 邀请码 -->
    <div v-show="isInviteName">
      <input type="tel" v-model="inviteName" placeholder="请输入邀请码" disabled />
    </div>
    <!-- 注册协议 -->
    <div class="check-list">
      <div @click="handleCheckBoxClick">
        <svg-icon :icon-class="checkboxSvgPath" class-name="cur-icon"></svg-icon>
      </div>
      <span>
        我已阅读并同意
        <span @click="handleToAgreementClick">《注册协议》</span>
      </span>
    </div>
    <!-- 按钮 -->
    <div class="button-list">
      <mt-button type="primary" size="large" plain v-if="isQrCode"
        @click="handleDownloadBtnClick">已有账户直接下载APP</mt-button>
      <mt-button type="primary" size="large" :disabled="registerBtnDisabled"
        @click="handleRegisterBtnClick">注册销售</mt-button>
    </div>
    <mt-popup class="register-agreement" v-model="agreementVisible">
      <div class="container">
        <div class="title">恒信通注册协议</div>
        <div class="content" v-html="hasNameAgreementText"></div>
        <div class="btn" @click="handleAgreementClose">关闭</div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
/* global
    PUBLIC_TOKEN,
    PUBLIC_REGISTER_LOGO,
    PUBLIC_WELCOME_CODE,
    PUBLIC_WELCOME_NAME,
    PUBLIC_APP_NAME,
    PUBLIC_AGREEMENT_TEXT,
    PUBLIC_WELCOME_QRCODE,
    PUBLIC_REGISTER_INTERFACE_FLAG,
    PUBLIC_SYSTEM_FLAG,
    PUBLIC_MOBILE_REGEXP,
    PUBLIC_PRODUCT,
    android_download_url,
    ios_download_url
*/

/* exported PUBLIC_TOKEN */

import { Indicator } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { GetTokenBySh, GetTokenByDls, GetMobileVerificationCode, GetSMSCode, RegUser, AddUser } from '@/api/interface';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';
import SvgIcon from '@/components/SvgIcon';

export default {
  name: 'Register',
  comments: { SvgIcon },
  data() {
    return {
      logoImgPath: require('@/assets/' + PUBLIC_REGISTER_LOGO),
      pwd1SvgEyePath: 'hide_money',
      pwd2SvgEyePath: 'hide_money',
      checkboxSvgPath: 'selected_coupons',
      pwd1InputType: 'password',
      pwd2InputType: 'password',
      timing: null,
      codeBtnDisabled: false,
      codeBtnLabel: '获取验证码',
      currentCheckedState: true,
      registerBtnDisabled: false,
      isQrCode: false,
      isReferralCode: false,
      isInviteName: false,
      mobileNum: '',
      validateCode: '',
      pwd1: '',
      pwd2: '',
      inviteCode: PUBLIC_WELCOME_CODE,
      inviteName: PUBLIC_WELCOME_NAME || PUBLIC_WELCOME_CODE,
      agreementVisible: false,
      appName: PUBLIC_APP_NAME,
      agreementText: PUBLIC_AGREEMENT_TEXT,
      referralCode: PUBLIC_REFERRAL_CODE || "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 判断入口路径
      this.isQrCode = PUBLIC_WELCOME_QRCODE === '1';
      // 根据标识调用不同接口
      switch (PUBLIC_REGISTER_INTERFACE_FLAG) {
        case '商户':
          this.isInviteName = true;
          this.isReferralCode = false;
          this.apiGetTokenBySh();
          break;
        case '代理商':
          this.isInviteName = false; // 2025.12.12 代理商不显示邀请码
          this.isReferralCode = false; // 2025.12.18 定的将销售功能废弃，所以将此开关变量设置为false
          this.apiGetTokenByDls();
          break;
      }
    });
  },
  computed: {
    hasNameAgreementText() {
      return this.agreementText.replace(/tmpCustomAppName/g, this.appName);
    },
  },
  methods: {
    // 验证手机号码
    validateMobileNumVal() {
      const val = this.mobileNum.replace(/\s/gi, '');
      if (val === '') {
        CusToast('手机号码不能为空');
        return 'err';
      }
      const regExp = PUBLIC_MOBILE_REGEXP;
      if (!regExp.test(val)) {
        CusToast('手机号码格式不正确');
        return 'err';
      }
      return 'ok';
    },
    // 验证短信验证码
    validateCodeVal() {
      if (this.validateCode === '') {
        CusToast('短信验证码不能为空');
        return 'err';
      }
      return 'ok';
    },
    // 验证密码框1
    validatePwd1Val() {
      if (this.pwd1 === '') {
        CusToast('登录密码不能为空');
        return 'err';
      }
      const arr = this.pwd1.split('');
      const isOk = /^[A-Za-z0-9]+$/.test(this.pwd1);
      if (arr.length < 6 || !isOk) {
        CusToast('登录密码为6位以上数字或字母');
        return 'err';
      }
      // 验证都是数字的情况下不能是相同\连续的数字
      if (/^[0-9]*[1-9][0-9]*$/.test(this.pwd1)) {
        const differ = [];
        const pwdArr = this.pwd1.split('');
        let count0 = 0;
        let count1 = 0;
        let count2 = 0;
        for (let i = 0; i < pwdArr.length - 1; ++i) {
          differ.push(pwdArr[i + 1] - pwdArr[i]);
        }
        for (let i = 0; i < differ.length; i++) {
          differ[i] === 0 && count0++;
          differ[i] === 1 && count1++;
          differ[i] === -1 && count2++;
        }
        if (count0 === differ.length) {
          CusToast('密码不能是重复的数字');
          return 'err';
        }
        if (count1 === differ.length) {
          CusToast('密码不能是连续的数字');
          return 'err';
        }
        if (count2 === differ.length) {
          CusToast('密码不能是连续的数字');
          return 'err';
        }
      }
      return 'ok';
    },
    // 验证再次输入密码框
    validatePwd2Val() {
      if (this.pwd1 !== this.pwd2) {
        CusToast('两次密码输入的不一致');
        return 'err';
      }
      return 'ok';
    },
    // 结束倒计时
    endTiming() {
      clearInterval(this.timing);
      this.codeBtnDisabled = false;
      this.codeBtnLabel = '获取验证码';
    },
    // 调用接口，获得token （商户使用）
    apiGetTokenBySh() {
      GetTokenBySh()
        .then(res => {
          const msg = SucceedHandle(res.code, res.msg, () => (PUBLIC_TOKEN = res.data.token));
          msg && CusToast(msg);
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口，获得token （代理商使用）
    apiGetTokenByDls() {
      GetTokenByDls()
        .then(res => {
          const msg = SucceedHandle(res.code, res.msg, () => (PUBLIC_TOKEN = res.data.token));
          msg && CusToast(msg);
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口，获取注册码（商户使用）
    apiGetMobileVerificationCode() {
      GetMobileVerificationCode({
        cityCode: '',
        MobileNumber: this.mobileNum.replace(/\s/gi, ''),
        welcomeCode: this.inviteCode,
      })
        .then(res => {
          const msg = SucceedHandle(res.code, res.msg, () => {
            let time = 60;
            this.codeBtnDisabled = true;
            const sendSms = function () {
              if (time > 0) {
                this.codeBtnLabel = time + '秒后重新获取';
                time -= 1;
              } else {
                this.endTiming();
              }
              return sendSms;
            }.bind(this);
            this.timing = setInterval(sendSms(), 1000);
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口，获取注册码（代理商使用）
    apiGetSMSCode() {
      GetSMSCode({
        flag: 1,
        inviteCode: this.inviteCode,
        mobile: this.mobileNum.replace(/\s/gi, ''),
      })
        .then(res => {
          const msg = SucceedHandle(res.code, res.msg, () => {
            let time = 60;
            this.codeBtnDisabled = true;
            const sendSms = function () {
              if (time > 0) {
                this.codeBtnLabel = time + '秒后重新获取';
                time -= 1;
              } else {
                this.endTiming();
              }
              return sendSms;
            }.bind(this);
            this.timing = setInterval(sendSms(), 1000);
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口，注册（商户使用）
    apiRegUser() {
      Indicator.open();
      RegUser({
        MobileNumber: this.mobileNum.replace(/\s/gi, ''),
        MobileNumberCode: this.validateCode,
        LoginPassword: this.pwd1,
        SharingSources: 'H5',
        welcomeCode: '',
        cityCode: '',
      })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.handleAddUserSuccess('注册成功');
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口，注册（代理商使用）
    apiAddUser() {
      Indicator.open();
      AddUser({
        code: this.validateCode,
        inviteCode: this.inviteCode,
        mobile: this.mobileNum.replace(/\s/gi, ''),
        password: this.pwd1,
        registerSalesperson: true,
        referralCode: this.referralCode,
      })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.handleAddUserSuccess('注册成功');
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 手机号keyup事件
    handleMobileNumKeyUp() {
      const last = this.mobileNum.charAt(this.mobileNum.length - 1);
      // 自动将非法字符替换成空
      this.mobileNum = '1234567890 '.indexOf(last) < 0 ? this.mobileNum.replace(last, '') : this.mobileNum;
      // 第3位自动加空格，格式为：XXX XXXX
      if (this.mobileNum.length === 4 && last !== ' ') {
        const arr = this.mobileNum.split('');
        arr.splice(3, 0, ' ');
        this.mobileNum = arr.join('');
      }
      // 第8位自动加空格，格式为：XXX XXXX XXXX
      if (this.mobileNum.length === 9 && last !== ' ') {
        const arr = this.mobileNum.split('');
        arr.splice(8, 0, ' ');
        this.mobileNum = arr.join('');
      }
    },
    // 清除手机号click事件
    handleClearMobileNumClick() {
      this.mobileNum = '';
    },
    // 短信验证码keyup事件
    handleCodeKeyUp() {
      const last = this.validateCode.charAt(this.validateCode.length - 1);
      // 自动将非法字符替换成空
      this.validateCode = '1234567890'.indexOf(last) < 0 ? this.validateCode.replace(last, '') : this.validateCode;
    },
    // 获取验证码按钮click事件
    handleCodeBtnClick() {
      if (this.validateMobileNumVal() === 'err') return;
      // 根据标识调用不同接口
      switch (PUBLIC_REGISTER_INTERFACE_FLAG) {
        case '商户':
          this.apiGetMobileVerificationCode();
          break;
        case '代理商':
          this.apiGetSMSCode();
          break;
      }
    },
    // 密码1keyup事件
    handlePwd1KeyUp() {
      const last = this.pwd1.charAt(this.pwd1.length - 1);
      // 自动将非法字符替换成空
      this.pwd1 = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.indexOf(last) < 0 ? this.pwd1.replace(last, '') : this.pwd1;
      // 自动将汉字符替换成空
      this.pwd1 = this.pwd1.replace(/[\u4E00-\u9FA5]/g, '');
    },
    // 显示密码1
    handleShowPwd1Click() {
      if (this.pwd1SvgEyePath === 'hide_money') {
        this.pwd1SvgEyePath = 'show_money';
        this.pwd1InputType = 'text';
      } else {
        this.pwd1SvgEyePath = 'hide_money';
        this.pwd1InputType = 'password';
      }
    },
    // 密码2keyup事件
    handlePwd2KeyUp() {
      const last = this.pwd2.charAt(this.pwd2.length - 1);
      // 自动将非法字符替换成空
      this.pwd2 = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.indexOf(last) < 0 ? this.pwd2.replace(last, '') : this.pwd2;
      // 自动将汉字符替换成空
      this.pwd2 = this.pwd2.replace(/[\u4E00-\u9FA5]/g, '');
    },
    // 显示密码2
    handleShowPwd2Click() {
      if (this.pwd2SvgEyePath === 'hide_money') {
        this.pwd2SvgEyePath = 'show_money';
        this.pwd2InputType = 'text';
      } else {
        this.pwd2SvgEyePath = 'hide_money';
        this.pwd2InputType = 'password';
      }
    },
    // 同意协议checkbox的change
    handleCheckBoxClick() {
      this.currentCheckedState = !this.currentCheckedState;
      this.registerBtnDisabled = !this.currentCheckedState;
      this.checkboxSvgPath = this.currentCheckedState ? 'selected_coupons' : 'unselected_coupons';
    },
    // 下载按钮click事件
    handleDownloadBtnClick() {
      this.handleAddUserSuccess('尚未开通此APP的下载');
    },
    // 注册按钮click事件
    handleRegisterBtnClick() {
      // 点击按钮的控件验证
      if (this.validateMobileNumVal() === 'err') return;
      if (this.validateCodeVal() === 'err') return;
      if (this.validatePwd1Val() === 'err') return;
      if (this.validatePwd2Val() === 'err') return;
      // 根据标识调用不同接口
      switch (PUBLIC_REGISTER_INTERFACE_FLAG) {
        case '商户':
          this.apiRegUser();
          break;
        case '代理商':
          this.apiAddUser();
          break;
      }
    },
    // 协议点击事件
    handleToAgreementClick() {
      this.agreementVisible = true;
    },
    // 关闭协议窗口事件
    handleAgreementClose() {
      this.agreementVisible = false;
    },
    // 处理注册成功后事件
    handleAddUserSuccess(msg) {
      // 判断是否是扫二维码进到此页面
      if (this.isQrCode) {
        // 是，则注册成功后跳转APP下载页面
        const key = PUBLIC_PRODUCT.toLowerCase().trim();
        switch (PUBLIC_SYSTEM_FLAG) {
          case 'android':
            if (android_download_url[key]) {
              if (Array.isArray(android_download_url[key])) {
                switch (android_download_url[key].length) {
                  case 1:
                    if (android_download_url[key][0].url) this.$router.push('/download');
                    else CusToast(msg);
                    break;
                  case 2:
                    if (android_download_url[key][0].url && android_download_url[key][1].url) {
                      this.$router.push('/download');
                    } else CusToast(msg);
                    break;
                }
              } else {
                CusToast(msg);
              }
            } else {
              CusToast(msg);
            }
            break;
          case 'ios':
            if (ios_download_url[key]) {
              if (Array.isArray(ios_download_url[key])) {
                switch (ios_download_url[key].length) {
                  case 1:
                    if (ios_download_url[key][0].url) this.$router.push('/download');
                    else CusToast(msg);
                    break;
                  case 2:
                    if (ios_download_url[key][0].url && ios_download_url[key][1].url) this.$router.push('/download');
                    else CusToast(msg);
                    break;
                }
              } else {
                CusToast(msg);
              }
            } else {
              CusToast(msg);
            }
            break;
        }
      } else {
        // 反之，则注册成功后发请求到APP，APP去处理下一步如何进行
        CusToast(msg);
        window.location.href = 'protocol://android';
      }
    },
    // 2024.4.25 销售码
    handleReferralCodeKeyUp() {
      const last = this.referralCode.charAt(this.referralCode.length - 1);
      // 自动将非法字符替换成空
      this.referralCode = '1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.indexOf(last) < 0 ? this.referralCode.replace(last, '') : this.referralCode;
    },
  },
};
</script>
